export default __webpack_public_path__ + "static/media/warning--roadworks--g8.eb9766c2.png";